export const SET_SALE_TRACKING_STATUS = 'SET_SALE_TRACKING_STATUS';
export const SEND_SALES_EVENT = 'SEND_SALES_EVENT';
